import { Event, Post } from "../types.ts";
import { WIDGET_DEFAULTS } from "./constants.ts";

export function WidgetWrapper<T extends Post>(
  logger: (event: Event) => void,
  posts: T[],
  widget: HTMLElement,
  viewableThreshold: number = WIDGET_DEFAULTS.INTERSECTION_THRESHOLD
): HTMLElement {
  try {
    const articleIds = posts.map((post) => post.id);
    logger({
      name: "widget_rendered",
      articleIds,
    });

    // Create intersection observer to track when widget is in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            entry.intersectionRatio >= viewableThreshold
          ) {
            logger({
              name: "widget_viewable",
              articleIds,
            });
            // Disconnect observer after first viewable event to avoid duplicate logs
            observer.disconnect();
          }
        });
      },
      {
        threshold: viewableThreshold,
        rootMargin: "0px 0px -50px 0px", // Trigger when widget is 50px into viewport
      }
    );

    // Start observing the widget
    observer.observe(widget);

    return widget;
  } catch (error) {
    console.error("[MM Recirculation Widget] Error in WidgetWrapper:", error);
    // Still return the widget even if observer fails
    return widget;
  }
}
